import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import translationDe from 'src/assets/i18n/de.json';
import translationEn from 'src/assets/i18n/en.json';

import { LocaleId } from './config';

export type TranslationMap = Record<string, string>;

export const SupportedLocale = new Map<LocaleId, { locale: {}[]; translation: TranslationMap }>([
  ['en', { locale: localeEn, translation: translationEn }],
  ['de', { locale: localeDe, translation: translationDe }],
]);
SupportedLocale.forEach((sl) => registerLocaleData(sl.locale));

export const DEFAULT_LOCALE: LocaleId = 'en';

export function getLocaleKey(language: string): LocaleId {
  // Handle undefined or null language codes
  if (!language) {
    return 'en'; // Default fallback
  }

  // normalize, as it comes in xx-YY format but Safari on iOS prior to 10.2 uses xx-yy
  let locale: LocaleId = language.toLowerCase() as LocaleId;

  // Handle xx-yy format (e.g., 'en-US' -> 'en')
  if (locale.includes('-')) {
    locale = locale.split('-')[0] as LocaleId;
  }

  // Return the normalized language code - backend will handle all languages dynamically
  return locale;
}
